import { type ReactElement } from 'react'
import * as S from './number-card.styled'
import { type NumberCardProps } from './number-card.props'

export function NumberCard ({ children, icon, logo, subtext }: NumberCardProps): ReactElement {
  return <S.NumberCard>
    {icon && <S.IconContainer>
      <img src={icon} alt="" />
    </S.IconContainer>}
    {logo && <figure>
      <img src={logo} alt="" />
    </figure>}
    <p>{children}</p>
    <small dangerouslySetInnerHTML={{ __html: subtext }} />
  </S.NumberCard>
}
